import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchWishlist } from '../store/slices/wishlistSlice';
import { isUserLoggedIn } from '@common/utils/auth/authService';

const WishlistInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isUserLoggedIn()) {
      dispatch(fetchWishlist());
    }
  }, [dispatch]);

  // Listen for user login events to fetch wishlist
  useEffect(() => {
    const handleLogin = () => {
      dispatch(fetchWishlist());
    };

    window.addEventListener('user-logged-in', handleLogin);
    return () => window.removeEventListener('user-logged-in', handleLogin);
  }, [dispatch]);

  return null; // This component doesn't render anything
};

export default WishlistInitializer;